var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    src: "/static/media/right-icon.76f4962d.svg",
    alt: "Right",
    loading: "lazy",
    style: {
      height: 20,
      right: 10,
      borderRadius: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .s0 { fill: var(--primary-color) } \n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 16C21.28 16.32 21.12 16.8 20.8 16.96C18.56 19.2 16.48 21.28 14.24 23.52C13.6 24.16 12.8 24.16 12.32 23.52C11.84 23.04 11.84 22.24 12.32 21.6C14.08 19.84 15.8399 17.92 17.76 16.16C17.92 16 17.92 15.84 17.76 15.68C15.9999 13.92 14.2399 12.16 12.4799 10.4C11.9999 9.92005 11.8399 9.28005 12.1599 8.80005C12.4799 8.00005 13.4399 7.84005 14.0799 8.32005C14.2399 8.32005 14.3999 8.48005 14.3999 8.64005C16.48 10.72 18.72 12.96 20.8 15.04C21.12 15.2 21.28 15.52 21.28 16Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.f49bb668.svg";
export { ForwardRef as ReactComponent };